import React from "react";

export default props => (
  <g
    className="text-list"
    transform="translate(361)"
    id={props.id ? props.id : null}
  >
    {props.list &&
      props.list.map((item, index) => (
        <text
          key={index}
          className="list-item"
          xmlSpace="preserve"
          textAnchor="middle"
          y={180 + index * 40}
          x="30"
          strokeWidth="0"
          stroke="null"
          fill={props.color ? props.color : "white"}
          style={{
            fontSize: props.fontSize ? props.fontSize : "20px"
          }}
        >
          {item}
        </text>
      ))}
  </g>
);



// WEBPACK FOOTER //
// ./src/components/Text/TextList.js